import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'svg-create-new-password-expired-svg',
  template: `<div class="svg-container">
  <svg height="93px" width="93px" viewBox="0 0 93 93" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Create-New-Password" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Link-expired" transform="translate(-143.000000, -107.000000)">
            <g id="09_ITEM/Hero/time_expired" transform="translate(140.000000, 104.000000)">
                <g id="np_time_1015020_737373" transform="translate(3.000000, 3.000000)" fill="#737373">
                    <path d="M45.5,0 C20.41,0 0,20.41 0,45.5 C0,70.59 20.41,91 45.5,91 C70.59,91 91,70.59 91,45.5 C91,20.41 70.59,0 45.5,0 Z M45.5,84 C24.27,84 7,66.73 7,45.5 C7,24.27 24.27,7 45.5,7 C66.73,7 84,24.27 84,45.5 C84,66.73 66.73,84 45.5,84 Z M49,14.336 L42,14.336 L42,46.988 L60.242,64.523 L65.0936,59.4761 L48.9996,44.0111 L49,14.336 Z" id="Shape" fill-rule="nonzero"></path>
                </g>
                <g id="Group" transform="translate(66.000000, 66.000000)">
                    <circle id="Oval" fill="#FFFFFF" fill-rule="nonzero" cx="15" cy="15" r="15"></circle>
                    <path d="M15.5,27 C8.59644063,27 3,21.4035594 3,14.5 C3,7.59644063 8.59644063,2 15.5,2 C22.4035594,2 28,7.59644063 28,14.5 C28,21.4035594 22.4035594,27 15.5,27 Z M15.5,23.875 C20.6776695,23.875 24.875,19.6776695 24.875,14.5 C24.875,9.32233047 20.6776695,5.125 15.5,5.125 C10.3223305,5.125 6.125,9.32233047 6.125,14.5 C6.125,19.6776695 10.3223305,23.875 15.5,23.875 Z" id="Combined-Shape" fill="#BF4B49" fill-rule="nonzero"></path>
                    <text id="!" font-family="NotoSans-Bold, Noto Sans" font-size="16" font-weight="bold" fill="#BF4B49">
                        <tspan x="12" y="20">!</tspan>
                    </text>
                </g>
            </g>
        </g>
    </g>
  </svg></div>`
})
export class CreateNewPasswordExpiredSvgComponent {}
